import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#fff",
      "stroke-linejoin": "round"
    }, [
      _createElementVNode("path", { d: "M13.333 7.334H2.667A.667.667 0 0 0 2 8.001v6c0 .368.298.666.667.666h10.666a.667.667 0 0 0 .667-.666V8a.667.667 0 0 0-.667-.667Z" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M4.667 7.334V4.667a3.333 3.333 0 0 1 6.667 0v2.667M8 10v2"
      })
    ], -1)
  ])))
}
export default { render: render }